export default __webpack_public_path__ + "static/media/1.9aa60ce3.jpg";